
(function(){
  var ubVariantImgKey = {
    '62691260629151': 'BY-ARTIC-BERRIE',
    '62691260596383': 'BY-CITRUS',
    '62691260661919': 'BY-STRAWBERRY'
  };

  window.ubSwapImage = function(variantId) {
    var key = ubVariantImgKey[String(variantId)];
    if (!key) return;
    var wrapper = document.querySelector('.product-media__items-wrapper');
    if (!wrapper) return;
    var imgs = wrapper.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      var src = (imgs[i].src || '').toUpperCase();
      if (src.indexOf(key) !== -1) {
        var media = imgs[i].closest('.media') || imgs[i].parentElement;
        if (media) {
          media.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        var thumbs = document.querySelectorAll('.product-thumbnails img');
        for (var j = 0; j < thumbs.length; j++) {
          var tsrc = (thumbs[j].src || '').toUpperCase();
          if (tsrc.indexOf(key) !== -1) {
            thumbs[j].click();
            break;
          }
        }
        break;
      }
    }
  };

  var origFlav = window.ubFlav;
  window.ubFlav = function() {
    if (origFlav) origFlav();
    var activeCard = document.querySelector('.ub__card.ub--sel');
    if (!activeCard) return;
    var qty = activeCard.getAttribute('data-qty');
    if (qty === '1') {
      var sel = document.querySelector('[data-flav="1"]');
      if (sel) window.ubSwapImage(sel.value);
    } else {
      var s2a = document.querySelector('[data-flav="2a"]');
      if (s2a) window.ubSwapImage(s2a.value);
    }
  };

  setTimeout(function() { if (window.ubFlav) window.ubFlav(); }, 500);
})();
